import React from 'react';

export const AlertPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { type, title, message, dismissible, icon } = specificAttrs || {};
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  const typeStyles = {
    info: { background: '#DBEAFE', color: '#1E40AF', border: '#93C5FD', emoji: 'ℹ️' },
    success: { background: '#D1FAE5', color: '#065F46', border: '#6EE7B7', emoji: '✅' },
    warning: { background: '#FEF3C7', color: '#92400E', border: '#FCD34D', emoji: '⚠️' },
    error: { background: '#FEE2E2', color: '#991B1B', border: '#FCA5A5', emoji: '❌' }
  };
  
  const style = typeStyles[type || 'info'];
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div style={{
        background: style.background,
        color: style.color,
        border: `1px solid ${style.border}`,
        borderRadius: '8px',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px'
      }}>
      {icon !== false && <span style={{ fontSize: '20px' }}>{style.emoji}</span>}
      <div style={{ flex: 1 }}>
        {title && <div style={{ fontWeight: '600', marginBottom: '4px', fontSize: '14px' }}>{title}</div>}
        <div style={{ fontSize: '13px' }}>{message || 'Alert message'}</div>
      </div>
      {dismissible && (
        <button style={{
          background: 'transparent',
          border: 'none',
          fontSize: '18px',
          cursor: 'pointer',
          color: style.color,
          padding: 0,
          lineHeight: 1
        }}>×</button>
      )}
      </div>
    </div>
  );
};
